<template>
  <div>
    <DeleteModal modalId="modal-delete" @deleteToggle="deleteItem" />

    <b-card :title="$t('bloodBank.filter-blood-store')">
      <div>
        <b-row class="mt-3">
          <b-col md="4" cols="6">
            <AutoComplete
              v-model="blood_bottle_id"
              :label="$t('office.blood_bottle')"
              :placeholder="$t('office.blood_bottle')"
              :serializer="(val) => val.id"
              endpoint="bloodBottles"
              text-title="bottle_identifier"
            />
          </b-col>
          <b-col md="3" cols="4">
            <AutoComplete
              v-model="blood_transfusion_type_id"
              :label="$t('bloodBank.blood-transfusion-type')"
              :placeholder="$t('bloodBank.blood-transfusion-type')"
              param-query="name"
              :serializer="(val) => val.id"
              endpoint="bloodTransfusionTypes"
              text-title="name"
              keyword="name"
            />
          </b-col>
          <b-col md="2" cols="4">
            <b-form-group
              :label="$t('bloodBank.patient-abo')"
              label-for="patient_abo"
            >
              <v-select
                v-model="patient_abo"
                :options="aboOptions"
                placeholder="A, B, AB, O"
              />
            </b-form-group>
          </b-col>

          <b-col md="3" cols="4">
            <b-form-group
              :label="$t('bloodBank.patient-rh')"
              label-for="patient_rh"
            >
              <v-select
                v-model="patient_rh"
                :options="rhOptions"
                placeholder="Positive, Negative"
              />
            </b-form-group>
          </b-col>
        </b-row>

        <b-row class="mt-2 mb-3">
          <b-col md="4" cols="6">
            <b-form-group
              :label="$t('bloodBank.search-from-to-by')"
              label-for="rh"
            >
              <v-select
                v-model="searchDate"
                :options="searchFromToBy"
                :placeholder="$t('bloodBank.search-from-to-by')"
              />
            </b-form-group>
          </b-col>

          <b-col md="4" cols="6">
            <b-form-group
              v-if="selectedSearch.key === 'created_at'"
              :label="$t(`${selectedSearch.label || ''} From`)"
              label-for="production_date"
            >
              <datepicker
                v-model="from_date"
                :calendar-button="true"
                :clear-button="true"
                :bootstrap-styling="true"
                class="datebtn2"
                placeholder="YYYY-MM-DD"
              ></datepicker>
            </b-form-group>
            <!-- <b-form-group v-else :label="$t('bloodBank.choose-value-max') + ' ' + $t(selectedSearch.label)"
                              label-for="from_value">
                              <b-form-input v-model="from_value" type="number"></b-form-input>
                          </b-form-group> -->
          </b-col>
          <b-col md="4" cols="6">
            <b-form-group
              v-if="selectedSearch.key === 'created_at'"
              :label="$t(`${selectedSearch.label || ''} To`)"
              label-for="expiration_date"
            >
              <datepicker
                v-model="to_date"
                :calendar-button="true"
                :clear-button="true"
                :bootstrap-styling="true"
                class="datebtn2"
                placeholder="YYYY-MM-DD"
              ></datepicker>
            </b-form-group>

            <!-- <b-form-group v-else :label="$t('bloodBank.choose-value-min') + ' ' + $t(selectedSearch.label)"
                              label-for="to_value">
                              <b-form-input v-model="to_value" type="number"></b-form-input>
                          </b-form-group> -->
          </b-col>
        </b-row>

        <!-- Search Button -->
        <b-row>
          <b-col cols="12" md="12">
            <br />
          </b-col>
          <b-col
            cols="12"
            md="12"
            class="d-flex align-items-center justify-content-end mb-1 mb-md-0"
          >
            <b-button variant="primary" @click="getBloodTransfusions()">
              {{ $t("common.search") }}
              <b-icon-search class="ml-1"></b-icon-search>
            </b-button>
            <!-- <b-button variant="primary" v-print="IVF" class="mx-2">
                              {{ $t("surgery.Print-Hospital-Expenses") }}
                          </b-button> -->
          </b-col>
        </b-row>
        <!-- Data Table  -->
        <div class="d-flex justify-content-between mt-4 mb-2">
          <h2>{{ $t("bloodBank.blood-transfusions-table") }}</h2>
          <!-- <b-button variant="primary" @click="show(EditForm, 'create')">
            {{ $t("bloodBank.add-blood-transfusions") }}
          </b-button> -->
        </div>

        <b-table
          :items="data"
          responsive
          :fields="bloodBottleTableColumns"
          primary-key="id"
          show-empty
          empty-text="No matching results found (SHOW ONLY COMPATIBLE BLOOD BOTTLES)"
          class="position-relative"
          v-if="!loading"
        >
          <!-- <template #cell(blood_transfusion.patient_card_id)="data">
            <p class="text-nowrap">
              {{ getPatientCard(data.item.blood_transfusion.patient_card_id) }}
            </p>
          </template> -->

          <template #cell(patient_abo)="data">
            <p style="font-size: 1.2rem">{{ data.item.patient_abo }}</p>
          </template>
          <template #cell(patient_rh)="data">
            <p style="font-size: 1.2rem">{{ data.item.patient_rh }}</p>
          </template>
          <template #cell(number_of_units)="data">
            <p style="font-size: 1.2rem">{{ data.item.number_of_units }}</p>
          </template>

          <template #cell(bottle_identifier)="data">
            <b-badge variant="secondary">
              {{ getNestedProperty(data.item, 'blood_bottle.bottle_identifier') }}
              <!-- {{ data.item.blood_bottle.bottle_identifier }} -->

            </b-badge>
          </template>

          <template #cell(final_result)="data">
            <b-badge :variant="data.item.final_result == 'compatible' ? 'success' : 'danger'"> {{ data.item.final_result }} </b-badge>
          </template>

          <template #cell(blood_transfusion.blood_transfusion_type_id)="data">
            <p>
              {{
                getTransfusionType(
                  data.item.blood_transfusion.blood_transfusion_type_id
                )
              }}
            </p>
          </template>

          <template #cell(update_info)="data">
            <b-button
              size="sm"
              pill
              variant="outline-secondary"
              @click="
                $router.push({
                  name: 'blood-compatibility-update',
                  params: {
                    blood_compatibility_id: data.item.id,
                    pateint_card_id: data.item.blood_transfusion.patient_card_id,
                  },
                })
              "
            >
              {{ $t("office.update-info") }}
            </b-button>
          </template>

          <!-- Column: Actions -->
          <template #cell(actions)="data">
            <div class="text-nowrap">
              <ActionsButtons
                deletePerm="get-bloodTransfusion"
                editPerm="get-bloodTransfusion"
                @editToggle="show(data.item)"
                @deleteToggle="deleteModel(data.item)"
              />
            </div>
          </template>
        </b-table>
        <template v-if="loading">
          <div>
            <div class="d-flex justify-content-center mb-1">
              <b-spinner label="Loading..." />
            </div>
          </div>
        </template>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
              @click="getBloodTransfusions()"
            >
              <b-pagination
                v-model="page"
                :total-rows="dataCount"
                :per-page="take"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </div>
    </b-card>

    <IVF :data="data" type="Hospital" />
  </div>
</template>

<script>
import {
  BCard,
  BFormGroup,
  BButton,
  BFormCheckbox,
  BCol,
  BRow,
  BFormInput,
  BTable,
  BDropdown,
  BDropdownItem,
  BPagination,
  BSpinner,
  BFormTextarea,
  BFormSelect,
  BFormDatepicker,
  BBadge,
  BCardText,
} from "bootstrap-vue";
import vSelect from "vue-select";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import VuePhoneNumberInput, { async } from "vue-phone-number-input";
import "vue-phone-number-input/dist/vue-phone-number-input.css";
import Datepicker from "vuejs-datepicker";
import StatisticCardHorizontal from "@core/components/statistics-cards/StatisticCardHorizontal.vue";
const IVF = () => import("@/components/printables/IVF.vue");
const Doctor = () => import("@/components/printables/Doctor.vue");
import permissionChecker from "@/mixins/permissionChecker";
import DeleteModal from "@/components/modals/DeleteModal.vue";
import ActionsButtons from "@/components/common/ActionsButtons.vue";
const AutoComplete = () => import("@/components/common/AutoComplete.vue");
import axios from "axios";
export default {
  mixins: [permissionChecker],

  components: {
    DeleteModal,
    BFormCheckbox,
    ActionsButtons,
    BCard,
    BFormGroup,
    BButton,
    BCol,
    BRow,
    BFormInput,
    BTable,
    BDropdown,
    BDropdownItem,
    BPagination,
    BSpinner,
    VuePhoneNumberInput,
    Datepicker,
    BFormTextarea,
    StatisticCardHorizontal,
    BBadge,
    IVF,
    Doctor,
    AutoComplete,
    BFormSelect,
    BFormDatepicker,
    BCardText,
    vSelect,
  },
  data() {
    return {
      take: 1000,
      loading: true,
      dataCount: 0,
      data: [],
      EditForm: {
        patient_card_id: "",
        patient_abo: "",
        patient_rh: "",
        blood_transfusion_type_id: "",
        _method: "PUT",
      },
      createMode: false,
      errorForm: {
        patient_card_id: "",
        patient_abo: "",
        patient_rh: "",
        blood_transfusion_type_id: "",
      },
      params: {
        form: {},
        path: "",
      },
      bloodBottleTableColumns: [
        // {
        //   key: "blood_transfusion.patient_card_id",
        //   sortable: true,
        //   label: this.$t("bloodBank.patient-name"),
        // },
        {
          key: "bottle_identifier",
          sortable: true,
          label: this.$t("bloodBank.bottle-identifier"),
        },
        {
          key: "blood_transfusion.blood_transfusion_type_id",
          sortable: true,
          label: this.$t("bloodBank.blood-transfusion-type"),
        },
        {
          key: "blood_transfusion.patient_abo",
          sortable: true,
          label: this.$t("bloodBank.patient-abo"),
        },
        {
          key: "blood_transfusion.patient_rh",
          sortable: true,
          label: this.$t("bloodBank.patient-rh"),
        },

        {
          key: "blood_transfusion.number_of_units",
          sortable: true,
          label: this.$t("bloodBank.number-of-units"),
        },
        {
          key: "final_result",
          sortable: true,
          label: this.$t("bloodBank.final-result"),
        },
        {
          key: "update_info",
          sortable: true,
          label: this.$t("office.update-info"),
        },

        // {
        //   key: "Actions",
        //   label: this.$t("common.actions"),
        //   thStyle: { width: "150px" },
        // },
        {
          key: "created_at",
          sortable: true,
          label: this.$t("common.created-at"),
        },
      ],

      aboOptions: ["A", "B", "AB", "O"],
      rhOptions: ["Positive", "Negative"],
      currentPage: 1,
      takeOptions: [10, 25, 50, 100],
      page: 1,
      IVF: {
        id: "IVF",
      },

      abo: "",
      rh: "",
      production_date: "",
      expiration_date: "",
      bottle_identifier: "",
      inserted_at: "",
      searchFromToBy: [
        {
          key: "created_at",
          label: this.$t("bloodBank.created_at"),
          from: "created_at-ge",
          to: "created_at-le",
        },
      ],
      statusOptions: ["available", "dispensed"],
      searchDate: "",
      selectedSearch: "",
      from_date: "",
      to_date: "",
      status: "",
      from_value: "",
      to_value: "",
      blood_transfusion_type_id: "",
      blood_bottle_id: "",
      patient_abo: "",
      patient_rh: "",
      number_of_units: "",
      room_temperature: "",
      incubator_temperature: "",
      transfusionTypes: [],
    };
  },
  mounted() {
    this.getTransfusionTypeList();
    this.getBloodTransfusions();
  },
  watch: {
    searchDate(newVal) {
      this.from_date = "";
      this.from_value = "";
      this.to_date = "";
      this.to_value = "";
      this.selectedSearch = newVal || "";
    },
  },
  methods: {
    async getTransfusionTypeList() {
      await this.getList(`/bloodTransfusionTypes`);
      this.transfusionTypes = this.all_data.data;
      console.log("this.transfusionTypes", this.transfusionTypes);
    },
    getNestedProperty(obj, path, defaultValue = "N/A") {
      const result = path
        .split(".")
        .reduce(
          (acc, part) => (acc && acc[part] ? acc[part] : defaultValue),
          obj
        );
      console.log("result", result);
      return result;
    },
    formatDate(ivfDate) {
      const date = new Date(ivfDate);
      const year = date.getFullYear();
      let month = "" + (date.getMonth() + 1);
      let day = "" + date.getDate();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return `${year}-${month}-${day}`;
    },
    show(item, mode) {
      console.log("item", item);
      if (mode === "create") {
        this.createMode = true;
        this.EditForm = {
          _method: "POST",
        };
      } else {
        this.createMode = false;
        this.EditForm.id = item.id;
        this.EditForm.patient_card_id = item.patient_card_id;
        this.EditForm.patient_abo = item.patient_abo;
        this.EditForm.patient_rh = item.patient_rh;
        this.EditForm.blood_transfusion_type_id =
          item.blood_transfusion_type_id;
        this.EditForm.number_of_units = item.number_of_units;

        this.EditForm._method = "PUT";
      }
      this.$bvModal.show("modal-edit");
    },
    async getBloodTransfusions() {
      this.loading = true;
      // check if there are any null value in the obj we sending

      let url = `/bloodCompatibilities?page=${this.page}&take=${
        this.searchDate &&
        (this.from_date || this.to_date || this.from_value || this.to_value)
          ? 1000
          : 15
      }&sort=-id&filter[final_result]=compatible&include[]=bloodBottle&include[]=bloodTransfusion&include[]=bloodTransfusionReaction&include[]=vitalSigns`;

      if (this.blood_bottle_id) {
        url += `&filter[blood_bottle_id]=${this.blood_bottle_id}`;
      }
      if (this.patient_abo) {
        url += `&filter[patient_abo]=${this.patient_abo}`;
      }
      if (this.patient_rh) {
        url += `&filter[patient_rh]=${this.patient_rh}`;
      }
      if (this.blood_transfusion_type_id) {
        url += `&filter[blood_transfusion_type_id]=${this.blood_transfusion_type_id}`;
      }

      if (this.from_date) {
        url += `&filter[${this.searchDate.from}]=${this.formatDate(
          this.from_date
        )}`;
      }
      if (this.to_date) {
        url += `&filter[${this.searchDate.to}]=${this.formatDate(
          this.to_date
        )}`;
      }

      if (this.from_value) {
        url += `&filter[${this.searchDate.from}]=${this.from_value}`;
      }
      if (this.to_value) {
        url += `&filter[${this.searchDate.to}]=${this.to_value}`;
      }

      await this.getList(url);
      this.dataCount = this.all_data.total;
      this.data = this.all_data.data;
      this.data = this.data.filter((item) => item.final_result == "compatible");
      this.loading = false;
      // console.log("this.data", this.data);
    },
    // async getPatientCard(id) {
    //   await this.getList(`/patientCard/${id}`);
    //   const patientCard = this.all_data.data;
    //   console.log("this.patientCard", patientCard);
    //   return patientCard;
    // },

    deleteModel(item) {
      this.deleteForm = item;
      this.$bvModal.show("modal-delete");
    },
    deleteItem() {
      this.$store
        .dispatch("delete", `/bloodTransfusions/${this.deleteForm.id}`)
        .then((response) => {
          this.getBloodTransfusions();

          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Delete Success",
              icon: "success",
              variant: "info",
              text:
                "deleted " +
                this.deleteForm.bottle_identifier +
                " successfully",
            },
          });
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            position: "top-right",
            props: {
              title: "Error",
              variant: "danger",
              text: "Error deleting " + this.deleteForm.bottle_identifier,
            },
          });
        });
    },

    submitItem() {
      let count = 0;
      this.loading = true;
      this.errorForm.patient_card_id = "";
      this.errorForm.patient_abo = "";
      this.errorForm.patient_rh = "";
      this.errorForm.blood_transfusion_type_id = "";
      for (let item in this.errorForm) {
        this.errorForm[item] = "";
        if (this.EditForm[item] == "" || this.EditForm[item] == null)
          delete this.EditForm[item];
      }

      if (!this.EditForm.patient_card_id) {
        count++;
        this.errorForm.patient_card_id =
          "The patient card id field is required.";
      }
      if (!this.EditForm.patient_abo) {
        count++;
        this.errorForm.patient_abo = "The ABO field is required.";
      }
      if (!this.EditForm.patient_rh) {
        count++;
        this.errorForm.patient_rh = "The RH field is required.";
      }
      if (!this.EditForm.blood_transfusion_type_id) {
        count++;
        this.errorForm.blood_transfusion_type_id =
          "The blood transfusion type field is required.";
      }

      console.log("editForm", this.EditForm);
      if (count > 0) {
        this.loading = false;
        return false;
      }

      if (this.createMode) {
        (this.params.form = this.EditForm),
          (this.params.path = `/bloodTransfusions`),
          this.$store
            .dispatch("create", this.params)
            .then((response) => {
              this.$bvModal.hide("modal-edit");
              this.loading = false;
              console.log("this.expenses", this.expenses);
              this.getBloodTransfusions();
            })
            .catch((error) => {
              this.loading = false;
              if (error.response.status === 400) {
                for (let item in error.response.data) {
                  this.$toast({
                    component: ToastificationContent,
                    position: "top-right",
                    props: {
                      title: "validation error",
                      variant: "danger",
                      text: error.response.data[item][0],
                    },
                  });
                }
              }
            });
      } else {
        (this.params.form = this.EditForm),
          (this.params.path = `/bloodTransfusions/${this.EditForm.id}`),
          this.$store
            .dispatch("update", this.params)
            .then((response) => {
              this.$bvModal.hide("modal-edit");
              this.loading = false;
              this.getBloodTransfusions();
            })
            .catch((error) => {
              this.loading = false;
              if (error.response.status === 400) {
                for (let item in error.response.data) {
                  this.$toast({
                    component: ToastificationContent,
                    position: "top-right",
                    props: {
                      title: "validation error",
                      variant: "danger",
                      text: error.response.data[item][0],
                    },
                  });
                }
              }
            });
      }
    },
    getTransfusionType(id) {
      const transfusionType = this.transfusionTypes;
    //   console.log("transfusionType1111", transfusionType);

      if (id) {
        // console.log("id", id);
        const writeType = transfusionType.find((type) => type.id === id);
        // console.log("writeType", writeType);
        return writeType.name;
      }

      //   return transfusionType;
    },
  },
};
</script>
<style scoped>
/* CSS */
.button-preview {
  align-items: center;
  appearance: none;
  background-color: #fff;
  border: 1px solid #dbdbdb;
  border-radius: 0.375em;
  box-shadow: none;
  box-sizing: border-box;
  color: #363636;
  cursor: pointer;
  display: inline-flex;
  font-family: BlinkMacSystemFont, -apple-system, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", Helvetica,
    Arial, sans-serif;
  font-size: 1rem;
  height: 2.5em;
  justify-content: center;
  line-height: 1.5;
  padding: calc(0.5em - 1px) 1em;
  position: relative;
  text-align: center;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  vertical-align: top;
  white-space: nowrap;
  margin-bottom: 3px;
  margin-right: 10px;
}

.button-preview:active {
  border-color: #4a4a4a;
  outline: 0;
}

.button-preview:focus {
  border-color: #485fc7;
  outline: 0;
}

.button-preview:hover {
  border-color: #b5b5b5;
  background: rgb(245, 241, 241);
}

.button-preview:focus:not(:active) {
  box-shadow: rgba(72, 95, 199, 0.25) 0 0 0 0.125em;
}

.modify {
  height: 6rem;
  font-size: 2rem;
  align-items: center;
}

.modify:hover {
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
